/* src/app/components/info-despagination-modal/info-despagination-modal.component.scss */
.container {
  padding: 10px;
  background: #f6f6f6;
}
.title {
  color: #eb445a;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}
.option {
  padding: 10px 10px 15px 10px;
  border-radius: 10px;
  border: 1px solid var(--0-Neutros-GRIS-3, #949494);
  margin-bottom: 15px;
  width: 100%;
}
.option .option_title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 22px;
  font-weight: 500;
}
.option .option_subtext {
  color: #949494;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}
.option .title_annotation {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 12px;
  padding: 5px 8px;
  border-radius: 20px;
}
.option .title_annotation.pink {
  color: #c80064;
  background-color: #ffd5eb;
}
.option .title_annotation.blue {
  color: #43c0f6;
  background-color: #d4ecff;
}
.coverTypeIcon {
  height: 75px;
  width: 72px;
}
/*# sourceMappingURL=info-despagination-modal.component-EHMZTMHQ.css.map */
